import Vue from 'vue'
import oAuthService from './service'
import helpers from './helpers'
export default {
  refreshToken ({state, commit, rootState}, data) {
    return new Promise((resolve, reject) => {
      if (!helpers.currentTokenValid(state.expiresIn, state.expiresFrom) && !state.hasCurrentActiveRequest) {
        commit('UPDATE_ACTIVE_REQUEST_TOGGLE', true)
        oAuthService.getToken(rootState.authentication.token)
          .then(({data}) => {
            if (typeof data.access_token !== 'undefined') {
              commit('SET_TOKEN', data.access_token)
              commit('UPDATE_TIMINGS', data.expires_in)
              commit('UPDATE_ACTIVE_REQUEST_TOGGLE', false)
              resolve()
            } else {
              commit('UPDATE_ACTIVE_REQUEST_TOGGLE', false)
              reject()
            }
          })
          .catch((err) => {
            console.log(err)
            reject()
          })
      } else {
        resolve()
      }
    })
  },
  addTokenFromLogin ({state, commit}, token) {
    return new Promise((resolve, reject) => {
      commit('SET_TOKEN', token)
      resolve()
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/authorization/store/actions.js